import React, { useMemo, useState } from 'react'
import ItemMenuSquares, { _imsTypes } from './ItemMenuSquares'
import { Icon, Label } from 'semantic-ui-react'
import _ from 'lodash'
import Wrapper, { wrapperTypes } from './Wrapper'
import { renderHtml, renderHtmlXXX } from 'global/components/html/renderHtml'

export const ScheduleSquares = ({ items }) => {

  const [selectedDate, setSelectedDate] = useState()

  const content_dates = useMemo(() => {
    const ds = _.groupBy(items, 'startDate')
    return ds
  }, [items])

  const content_schedule = useMemo(() => {
    return content_dates?.[selectedDate]
  }, [selectedDate])

  const handleSelect_date = (item) => setSelectedDate(item.key)

  const fnAlt_date = (item) => <Label size='mini' color='blue'>{_.size(item)}</Label>

  const cal_startEnd = (startDate, startTime, endTime) => {
    return <div style={{ display: 'flex', borderRadius: '8px', justifyContent: 'space-between', backgroundColor: 'var(--off-black-4)', padding: '.5em', alignItems: 'center' }}>
      <Label size='mini' color={'green'}>{startTime}</Label>
      <div><Icon name='clock' color={'blue'} /></div>
      <Label size='mini' color={'red'}>{endTime}</Label>
    </div>
  }

  const cal_location = (description) => {
    return <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'black', padding: '.5em', alignItems: 'center' }}>
      {renderHtmlXXX(description)}
    </div>
  }

  const fnSub = (item) => {
    const { startDate, startTime, endTime, description } = item
    return <div style={{ display: 'flex', borderRadius: '8px', flexDirection: 'column', justifyContent: 'space-between', rowGap: '1em', backgroundColor: 'var(--off-black-3)' }}>
      {cal_startEnd(startDate, startTime, endTime)}
      {description && cal_location(description)}
    </div>
  }

  const ims_dates = () => <ItemMenuSquares
    menuItems={content_dates}
    imsType={_imsTypes.inline}
    fn_altContent={fnAlt_date}
    onClick={handleSelect_date}
  ></ItemMenuSquares>

  const header_schedule = () => <div style={{ display: 'flex', columnGap: '.5em' }}>
    <div><Icon name={'arrow left'} onClick={(e) => { setSelectedDate() }} /></div>
    <div>{selectedDate}</div>
  </div>

  const ims_schedule = () => <Wrapper
    header={header_schedule()}
    content={<ItemMenuSquares
      menuItems={content_schedule}
      imsType={_imsTypes.inline}
      fn_subContent={fnSub}
      iconItem={'calendar'}
    ></ItemMenuSquares>}
    wrapperType={wrapperTypes.padded}
  >
  </Wrapper>

  return _.isEmpty(content_schedule) ? ims_dates() : ims_schedule()


}
